export type PrefillSource = 'saved' | 'contact' | 'company' | 'default' | 'edited' | 'empty';
export type PrefillEntry = { value: string; source: PrefillSource };
export type PrefillMap = Record<string, PrefillEntry>;

const PLACEHOLDER_RE = /\{\{([^{}]+)\}\}/g;

// System placeholders (e.g. `system.now`, `system.timezone`, `system.now.date`) are computed
// by the backend at send time, so an empty user value for them is expected and must not trigger
// the "missing values" confirmation.
export function isSystemPlaceholder(name: string): boolean {
  return name === 'system' || name.startsWith('system.');
}

// `text` is the serialized message text produced by the editor
// (mentions already rendered as `{{placeholder}}` literals), not raw HTML.
export function extractPlaceholders(text: string): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const match of text.matchAll(PLACEHOLDER_RE)) {
    if (!seen.has(match[1])) {
      seen.add(match[1]);
      result.push(match[1]);
    }
  }
  return result;
}

export function renderTestMessageText(
  text: string | null | undefined,
  fields: PrefillMap,
  optOutText?: string | null,
): string {
  let rendered = text ?? '';
  for (const [placeholder, entry] of Object.entries(fields)) {
    rendered = rendered.split(`{{${placeholder}}}`).join(entry.value || `[${placeholder}]`);
  }
  return optOutText ? `${rendered} \n\n${optOutText}` : rendered;
}
